import { Container, Card } from 'react-bootstrap'
import { CardRowItem } from '../../cardRowItem'
import { IProposalTakeHomeSectionProps } from './proposalTypes'

interface IInputProps {
  data: IProposalTakeHomeSectionProps
  pdf?: boolean
  title: string
}
const takeHomeSection = (props: IInputProps) => {

  return (
    <div className="card-section print-page-break-before" id="takehomesection">
      <Container className="section mt-4">
        <Card
          className={
            props.pdf ? 'mb-13rem pdf-card-container' : 'mb-13rem card-shadow'
          }
        >
          <Card.Header
            className={
              props.pdf ? 'border-bottom-0 pdf-card' : 'border-bottom-0'
            }
          >
            <div className="text-header">{props.title}</div>
          </Card.Header>
          <Card.Body>
            <div className="font-weight-bold text-uppercase">Pre-tax</div>
            <CardRowItem
              title="Gross Income"
              value={props.data.grossSalaryPerPay}
              isCurrency="true"
              rightTextcss="text-right--bold"
            />
            <CardRowItem
              title="Pre-tax novated lease deduction"
              value={props.data.preTaxPerPay}
              isCurrency="true"
              normalWeight={true}
            />
            <CardRowItem
              title="Other salary packaging (Pre-tax)"
              value={props.data.otherPreTaxPerPay}
              isCurrency="true"
              hideIfNoValue="true"
            />
            <hr></hr>
            <div className="font-weight-bold">
              <CardRowItem
                title="Resulting taxable income"
                value={props.data.netSalaryPerPay}
                isCurrency="true"
                rightTextcss="text-right--bold"
              />
            </div>
            <div>
              {props.data.fbtPerPay > 0 && (
                <>
                  <CardRowItem
                    title="FBT"
                    value={props.data.fbtPerPay}
                    isCurrency="true"
                    normalWeight={true}
                  />
                </>
              )}

              <CardRowItem
                title="FBT"
                value={props.data.fbtPerPay}
                isCurrency="true"
                normalWeight={true}
                hideIfNoValue="true"
              />
              <CardRowItem
                title="Tax and medicare deduction"
                value={props.data.taxMedicarePerPay}
                isCurrency="true"
                normalWeight={true}
              />
              <br />
              <div className="font-weight-bold">
                <CardRowItem
                  title="Resulting net income"
                  value={props.data.netIncomePerPay}
                  isCurrency="true"
                  rightTextcss="text-right--bold"
                />
              </div>
              <hr></hr>
            </div>
            <div className="font-weight-bold text-uppercase">Post-tax</div>
            <CardRowItem
              title="Post-tax novated lease deduction (ECM)"
              value={props.data.postTaxPerPay}
              isCurrency="true"
              normalWeight={true}
            />
            <CardRowItem
              title="Other salary packaging items"
              value={props.data.otherPostTaxPerPay}
              isCurrency="true"
              hideIfNoValue="true"
            />
            <br />
            <div className="font-weight-bold">
              <CardRowItem
                title="Resulting take home pay"
                value={props.data.takeHomePerPay}
                isCurrency="true"
                rightTextcss="text-right--bold"
              />
            </div>

            <br />
            <div className="text-small">
              Disclaimer: The pre-tax salary in the calculations is net of your
              employer's compulsory superannuation guarantee contribution. The
              Tax and Medicare calculations do not take into account any
              HECS/HELP repayments that may apply to your personal financial
              circumstances.
            </div>
          </Card.Body>
        </Card>
      </Container>
    </div>
  )
}

export default takeHomeSection
